<script>
import * as utility from '@/utility';

// Component Mixin
export default {
  methods: {
    message(value) {
      return utility.formatPrice(value);
    },
    formatPrice(value) {
      if (value == null || value === '') {
        return '-';
      }
      return '￥' + String(Number(value)).split(/(?=(?:\d{3})+$)/).join();
    },
    formatPriceDoller(value) {
      if (value === '') {
        return '-';
      }
      return '＄' + String(Number(value)).split(/(?=(?:\d{3})+$)/).join();
    },
    formatDate(value) {
      return utility.formatDate(value);
    },
    formatNumber(value) {
      if (value === '') {
        return '-';
      }
      return String(Number(value));
    },
    checkStringBlank(value) {
      if(value === null || value === ''){
        return '-';
      }
      return value;
    },
    checkDateBlank(value) {
      if(value === null || value === ''){
        return '-';
      }
      return utility.formatDate(value);
    },
  },
};

</script>
